import {
  GENERAL_REQUEST_LOADING,

  REPORT_UPDATE_DATA,

  REPORT_CLEAR_DATA,
  REPORT_SET_DATA,
  REPORT_APPEND_DATA,
  REPORT_PAD_APPEND_DATA,
  REPORT_SET_INPUT_DATA,
  REPORT_RESET_INPUT_DATA,
  REPORT_FETCH_DATA_FAIL,
  REPORT_PAD_SET_DATA,

  //add report input clear

  REPORT_CLAIM_INFO,
  REPORT_CLAIM_INFO_SUCCESS,
  REPORT_CLAIM_INFO_FAIL,

  REPORT_SUMMARY_INFO,
  REPORT_SUMMARY_INFO_SUCCESS,
  REPORT_SUMMARY_INFO_FAIL,

  REPORT_BALANCE_INFO,
  REPORT_BALANCE_INFO_SUCCESS,
  REPORT_BALANCE_INFO_FAIL,
  
  REPORT_BUSINESS_CLAIM_INFO,
  REPORT_BUSINESS_CLAIM_INFO_SUCCESS,
  REPORT_BUSINESS_CLAIM_INFO_FAIL,
  REPORT_CLAIM_DETAILS_INFO,
  REPORT_CLAIM_DETAILS_INFO_SUCCESS,
  REPORT_CLAIM_DETAILS_INFO_FAIL,

  REPORT_PAD_REMOVE_DATA,

  LOGOUT,
  LOGOUT_TOOLS,
} from '../actions/types';

import { ISODateFormat } from '../utility/common/GlobalHSA';

export const INITIAL_STATE = {
  reportInput: {startdate: ISODateFormat(new Date().setMonth(new Date().getMonth() - 1)), enddate: ISODateFormat(), pageNumber: 1, pageLength: 50, reportType:'', refresh: true},
  initReportInput: {
    pageNumber: 1,
    pageLength: 30,
    fetchPage: 0,
    fetchLength: 600,
    endOfList: false,
    query: []
  },
  claimDetails: [ ],
  claimReport: [],
  summaryReport: [],
  balanceReport: [],
  claimReportFormatted: [],
  claimReportFlatFormatted: [],
  claimBusinessReport: [],
  claimBusinessReportFlat: [],
  error: false,
  errors: {},
  success: false,
  message: '',
  loading: false,
};
/*------------------- Partner --------------------*/
export const CLIENT_LIST_HEADER_INITIAL_STATE =
  [
    { label: "Employer ID", key: "EMPLOYER", format: '' },
    { label: "Company", key: "EMPLOYER_NAME", format: '' },
    { label: "Plan", key: "PLAN_CODE" , format: 'plan'},
    { label: "Effective Date", key: "EFFECTIVE_DATE", format: 'date' },
    { label: "Termination Date", key: "TERMINATION_DATE", format: 'date' },
    { label: "Last Claim", key: "LAST_CLAIM_DATE", format: 'date' },
    { label: "Travel Insurance", key: "TRAVL_INS", format: '' },
    { label: "EEI Insurance", key: "EEI_INS", format: '' },
  ];

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case REPORT_UPDATE_DATA:
        return (action.datagroup !== '')?
            { ...state, [action.datagroup]: {...state[action.datagroup], [action.dataname]: action.datavalue }, error: false, errors: {}, loading: false }
            :
            { ...state, [action.dataname]: action.datavalue, error: false, loading: false };
      case REPORT_SUMMARY_INFO:
        return {...state, loading: true };
      case REPORT_SUMMARY_INFO_FAIL:
        return {...state, summaryReport: INITIAL_STATE.summaryReport, error: true, errors: action.errors, loading: false };
      case REPORT_SUMMARY_INFO_SUCCESS:
        return {...state, summaryReport: action.data.summaryReport, error: false, errors: {}, message: action.data.message, loading: false };
      
      case REPORT_BALANCE_INFO:
        return {...state, loading: true };
      case REPORT_BALANCE_INFO_FAIL:
        return {...state, error: true, errors: action.errors, loading: false };
      case REPORT_BALANCE_INFO_SUCCESS:
        const balanceReport = Object.fromEntries(Object.entries(action.data).filter(([item]) => item.startsWith("balanceReport")));
        return {...state, ...balanceReport, error: false, message: action.data.message, errors: {}, loading: false };
      case REPORT_CLAIM_INFO:
        return {...state, loading: true };
      case REPORT_CLAIM_INFO_FAIL:
        return {...state, claimReport: INITIAL_STATE.claimReport, error: true, errors: action.errors, loading: false };
      case REPORT_CLAIM_INFO_SUCCESS:
        return {...state, claimReport: action.data.claimReport, error: false, errors: {}, message: action.data.message, loading: false };
      case REPORT_BUSINESS_CLAIM_INFO:
        return {...state, loading: true }
      case REPORT_BUSINESS_CLAIM_INFO_FAIL:
        return {...state, claimBusinessReport: INITIAL_STATE.claimBusinessReport, error: true, errors: action.errors, loading: false };
      case REPORT_BUSINESS_CLAIM_INFO_SUCCESS:
        return {...state,
            reportInput: {...state.reportInput, startdate: ISODateFormat(action.startdate), enddate: ISODateFormat(action.enddate)},
            claimBusinessReport: action.claimBusinessReport,
            claimBusinessReportFlat: action.claimBusinessReportFlat,
            claimBusinessReportSummary: action.claimBusinessReportSummary,
            error: false, errors: {}, message: action.message, loading: false };
      case REPORT_CLAIM_DETAILS_INFO:
        return {...state, loading: true };
      case REPORT_CLAIM_DETAILS_INFO_FAIL:
        return {...state, claimDetails: INITIAL_STATE.claimDetails, error: true, errors: action.errors, loading: false };
      case REPORT_CLAIM_DETAILS_INFO_SUCCESS:
        return {...state, claimDetails: action.claimDetails, error: false, errors: {}, message: action.message, loading: false };
      case REPORT_SET_DATA:
        return {...state, [action.reportName]: action.data.report, error: false, errors: {}, message: action.message, loading: false };
      case REPORT_PAD_SET_DATA:
        return {...state, [action.reportName]: action.data.auditPads, auditPadsType: action.data.auditPadsType, error: false, errors: {}, message: action.message, loading: false };
      case REPORT_PAD_REMOVE_DATA:
        if(!state[action.data.reportName])
          return {...state, error: false, errors: {}, message: action.data.message, loading: false };
        let auditPads = state[action.data.reportName];
        delete auditPads[action.data.id];
        return {...state, [action.data.reportName]: auditPads, error: false, errors: {}, message: action.data.message, loading: false };
      case REPORT_APPEND_DATA:
        const appendReport = (state[action.reportName])? Object.values(state[action.reportName]).concat(action.data.report): action.data.report;
        return {...state, [action.reportName]: appendReport, error: false, errors: {}, message: action.message, loading: false };
      case REPORT_PAD_APPEND_DATA:
        const appendPADReport = (state[action.reportName])? Object.values(state[action.reportName]).concat(action.data.auditPads): action.data.auditPads;
        return {...state, [action.reportName]: appendPADReport, reportType: action.data.auditPadsType, error: false, errors: {}, message: action.message, loading: false };
      case REPORT_CLEAR_DATA:
        return {...state, [action.reportName]: '', error: false, errors: {}, message: action.message, loading: false };
      case REPORT_FETCH_DATA_FAIL:
        return {...state, error: true, errors: '', loading: false };
      case REPORT_SET_INPUT_DATA:
        const appendInputName = action.reportName + 'ReportInput';
        return {...state, [appendInputName]: {...action.reportInput}, error: false, errors: {}, loading: false };
      case REPORT_RESET_INPUT_DATA:
        const resetInputName = action.reportName + 'ReportInput';
        return {...state, [resetInputName]: { ...INITIAL_STATE.initReportInput}, error: false, errors: {}, loading: false };
      case GENERAL_REQUEST_LOADING:
        return { ...state, error: false, errors: {}};
      case LOGOUT:
        return INITIAL_STATE;
      case LOGOUT_TOOLS:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
